export const PASSWORD_FIELD = 'password';
export const CAPTCHA_FIELD = 'captcha';

export const SIGN_IN_METHOD_PASSWORD = 'password';

export const REFERRAL_SESSION_KEY = 'referral_response';

export const SIGN_IN_METHOD_FACEBOOK_LOGIN = 'facebook_login';
export const SIGN_IN_METHOD_APPLE_LOGIN = 'apple_login';
export const SIGN_IN_METHOD_GOOGLE_LOGIN = 'google_login';

export const LINK_SOCIAL_ACCOUNT_SUCCESS = 'LINK_SOCIAL_ACCOUNT_SUCCESS';
export const UNLINK_SOCIAL_ACCOUNT_SUCCESS = 'UNLINK_SOCIAL_ACCOUNT_SUCCESS';

export const LOOK_UP_FORM = 'lookUpForm';
export const BASE_URL = '/signin';

export const ONBOARDING_REDIRECT_URL_BLACKLIST = [
    'create',
    'oauth',
    'organizations',
];

export const CREATOR_ONBOARDING_URL_WHITELIST = [
    '/reconvene',
    '/boost',
    '/contact-sales',
    '/blog',
    '/organizer',
    '/l/',
    '/manage/events/create',
];
export const CREATOR_ONBOARDING_URL_BLACKLIST = [
    '/l/covid',
    '/l/corona',
    '/l/eventbrite-app',
];

export const CREATOR_ONBOARDING_PATH = '/manage/events/create';

export const emailDomainSuggestions = [
    'gmail',
    'hotmail',
    'yahoo',
    'aol',
    'outlook',
    'icloud',
];

// Common domain emails
export const COMMON_DOMAIN_EMAILS: { [x: string]: string } = {
    'gmail.com': 'https://gmail.com/',
    'yahoo.com': 'https://mail.yahoo.com/',
    'hotmail.com': 'https://outlook.live.com/',
    'outlook.com': 'https://outlook.live.com/',
    'aol.com': 'https://mail.aol.com/',
    'icloud.com': 'https://www.icloud.com/mail',
};
